/**
 * Pomocnici pro casovy filtr rozsahu dni.
 *
 * DatePicker vraci vybrany den v 00:00. Pri striktnim porovnani nebo poslani
 * teto pulnoci na BE (dateTo >= creationDate) vypadne cely horni vybrany den.
 * Hranice se proto normalizuji na zacatek a konec dne.
 */
export const dayStart = (date: Date): Date => {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

export const dayEnd = (date: Date): Date => {
  const d = new Date(date)
  d.setHours(23, 59, 59, 999)
  return d
}

export const isWithinDateRange = (date: string | Date, from: Date, to: Date): boolean => {
  const time = new Date(date).getTime()
  return time >= dayStart(from).getTime() && time <= dayEnd(to).getTime()
}
